export const MAP_FIELDS_IN_CSV = [
	{
		from: 'kampania',
		to: 'campaign',
	},
	{
		from: 'dzie_',
		to: 'date',
	},
	{
		from: 'kod_waluty',
		to: 'currency',
	},
	{
		from: 'koszt',
		to: 'cost',
	},
];
